module.exports = __webpack_public_path__ + "images/328f3b437336c8ec52448152fcf8e5b3.png";